import { collection, doc, getDoc, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";

// Daily activity counts the app records for each bar (totals only):
// barStats/{barId}_{YYYY-MM-DD} = { seen, opened, calls, directions, website, saves, offersUsed }
// Dates follow the customer's phone (local day), which for this market is Central time.

export const STAT_FIELDS = ["seen", "opened", "calls", "directions", "website", "saves", "offersUsed"];

function ymd(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

/** The last `days` dates, oldest first, ending today. */
export function lastDates(days = 7) {
  const out = [];
  const now = new Date();
  for (let i = days - 1; i >= 0; i--) {
    const d = new Date(now);
    d.setDate(now.getDate() - i);
    out.push(ymd(d));
  }
  return out;
}

function emptyTotals() {
  return Object.fromEntries(STAT_FIELDS.map((f) => [f, 0]));
}

/** Totals for one bar over the last 7 days. */
export async function loadBarWeek(barId) {
  const totals = emptyTotals();
  if (!barId) return totals;
  const snaps = await Promise.all(lastDates(7).map((d) => getDoc(doc(db, "barStats", `${barId}_${d}`))));
  snaps.forEach((s) => {
    const data = s.data() || {};
    STAT_FIELDS.forEach((f) => {
      totals[f] += Number(data[f] || 0);
    });
  });
  return totals;
}

/** Totals for every bar over the last 7 days: [{ barId, barName, ...totals }]. */
export async function loadAllBarsWeek() {
  const start = lastDates(7)[0];
  const snap = await getDocs(query(collection(db, "barStats"), where("date", ">=", start)));
  const byBar = {};
  snap.docs.forEach((d) => {
    const data = d.data();
    if (!byBar[data.barId]) byBar[data.barId] = { barId: data.barId, barName: data.barName || "", ...emptyTotals() };
    const row = byBar[data.barId];
    if (data.barName) row.barName = data.barName;
    STAT_FIELDS.forEach((f) => {
      row[f] += Number(data[f] || 0);
    });
  });
  return Object.values(byBar);
}
